var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"containerbar"}},[_c('div',{staticClass:"rightbar"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 p-3 pt-0"},[_c('iframe',{attrs:{"width":"100%","height":"800","src":_vm.url.value,"frameborder":"0","allowFullScreen":"true"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }